module.exports = __webpack_public_path__ + "static/media/zig-zag.f37eef6f.png";